import {authRequest} from './index.js'


export async function get_faq(faq_id){
  let data
  await authRequest.get(
    'faqs/' + faq_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_faqs(){
  let data
  await authRequest.get(
    '/faqs'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_faq(faq){
  let data
  await authRequest.post(
    '/faqs',
    { faq },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_faq(faq_id){
  let data
  await authRequest.delete(
    '/faqs/' + faq_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_faq(faq_id, faq){
  let data
  await authRequest.patch(
    '/faqs/' + faq_id,
    { faq },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}